<template>
    <div v-if="loaded">
        <div v-if="type=='gas'">
            consumo Smc/anno:<br>
            <span>da 0 a 120</span> : {{values[0]}}<br>
            <span>da 121 a 480</span> :  {{values[1]}}<br>
            <span>da 481 a 1.560</span> :  {{values[2]}}<br>
            <span>da 1.561 a 5.000</span> :  {{values[3]}}<br>
            <span>da 5.001 a 80.000</span> :  {{values[4]}}<br>
            <span>da 80.001 a 200.000</span> :  {{values[5]}}<br>
        </div>
        <div v-if="type=='imposte'">
            consumo Smc/anno:<br>
            <span v-text="'consumo < 120 m3'"></span> : {{values[0]}}<br>
            <span v-text="'120 < consumo < 480 m3'"></span> :  {{values[1]}}<br>
            <span v-text="'480 < consumo < 1.560 m3'"></span> :  {{values[2]}}<br>
            <span v-text="'consumo > 1.560 m3'"></span> :  {{values[3]}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Scaglioni",
        components: {
        },
        props: {
            values: Array,
            type: String
        },
        data() {
            return {
                loaded: true,
            };
        },
        mounted() {
            console.log( 'Scaglioni mounted', this.values, this.type );
        },
        computed: {
                
        },
        methods: {

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>